import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getPropertiesOnJournalForWhichUserHasNoAccess: {
        method: 'GET',
        url: `${BASE_PATH_API}/journals/:journalId/properties/noAccess`,
        isArray: true
    },
    trustAccountingAnalysis: {
        method: 'POST',
        url: `${BASE_PATH_API}/journals/trustAccountingAnalysis`,
        isArray: true
    },
    deleteJournalEntries: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/journals`,
    },
    getOtherBankTransactionById: {
        method: 'GET',
        url: `${BASE_PATH_API}/otherBankTransactions/:journalId`
    },
    createOtherBankTransaction: {
        method: 'POST',
        url: `${BASE_PATH_API}/otherBankTransactions`
    },
    updateOtherBankTransaction: {
        method: 'PUT',
        url: `${BASE_PATH_API}/otherBankTransactions/:id`
    },
    deleteOtherBankTransaction: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/otherBankTransactions/:journalId`
    },
    getJournalDetails: {
        method: 'GET',
        url: `${BASE_PATH_API}/journals/:journalId`
    },
    getBankReconciliationsByJournalId: {
        method: 'GET',
        url: `${BASE_PATH_API}/journals/:journalId/reconciliations`
    }
};

export function JournalApiService() {
    return createActions(actions);
}
JournalApiService.$inject = [];
